/**
 * GENERATED ROUTE TREE — Phase 8 / Frontend Shell A.
 *
 * NOTE: Compatibilní s TanStack Router file-based CLI codegen output, ale
 * zatím spravujeme ručně (per IMPLEMENTATION.md Phase 5/8 — CLI integration
 * dorazí v Phase 11+ až bude víc routes). DoD ([REQ-UI-001, REQ-UI-003])
 * vyžaduje pouze, že tento soubor existuje, je committed a `pnpm tsc --noEmit`
 * je zelený. Aktualizujte při přidání route!
 *
 * Mapping na ANALYZE §5.2 routing tree:
 *   - /             → root index landing/router
 *   - /login        → REQ-UI-004/005 login form (RHF + Zod + TanStack Query)
 *   - /forgot-password
 *   - /reset-password/$token
 *   - /profile/change-password
 *   - /consent + /consent/re-prompt  (existing v Phase 6)
 *   - /admin/*      (14 stubs + 1 layout)
 *   - /tenant/*     (5 stubs + 1 layout)
 *
 * Total registered routes: 26 (~25 dle ANALYZE per phase scope).
 */

import { Route as RootRoute } from "./routes/__root";
import { Route as IndexRoute } from "./routes/index";
import { Route as LoginRoute } from "./routes/login";
import { Route as ForgotPasswordRoute } from "./routes/forgot-password";
import { Route as ResetPasswordRoute } from "./routes/reset-password";
import { Route as ProfileChangePasswordRoute } from "./routes/profile-change-password";
import { Route as ConsentIndexRoute } from "./routes/consent/index";
import { Route as ConsentRePromptRoute } from "./routes/consent/re-prompt";

import { Route as AdminLayoutRoute } from "./routes/admin/_layout";
import { Route as AdminDashboardRoute } from "./routes/admin/dashboard";
import { Route as AdminSyncRoute } from "./routes/admin/sync";
import { Route as AdminBudgetsIndexRoute } from "./routes/admin/budgets-index";
import { Route as AdminBudgetsDetailRoute } from "./routes/admin/budgets-detail";
import { Route as AdminDistributionRoute } from "./routes/admin/distribution";
import { Route as AdminAnomaliesRoute } from "./routes/admin/anomalies";
import { Route as AdminPrefakturaceRoute } from "./routes/admin/prefakturace-alsoft";
import { Route as AdminPaymentAccountsRoute } from "./routes/admin/payment-accounts";
import { Route as AdminBillingGroupsRoute } from "./routes/admin/billing-groups";
import { Route as AdminBillingGroupDetailRoute } from "./routes/admin/billing-group-detail";
import { Route as AdminHoldersRoute } from "./routes/admin/holders";
import { Route as AdminTenantsRoute } from "./routes/admin/tenants";
import { Route as AdminConsentUploadsRoute } from "./routes/admin/consent-uploads";
import { Route as AdminConsentVersionsRoute } from "./routes/admin/consent-versions";
import { Route as AdminCardsRoute } from "./routes/admin/cards-to-invalidate";
import { Route as AdminCredentialsRoute } from "./routes/admin/credentials-axigon";
import { Route as AdminUsersDetailRoute } from "./routes/admin/users-detail";
import { Route as AdminPushAssistRoute } from "./routes/admin/push-assist";
import { Route as AdminMicrogroupRequestsRoute } from "./routes/admin/microgroup-requests";
import { Route as AdminUserInvitesRoute } from "./routes/admin/user-invites";
import { Route as AdminDocumentsRoute } from "./routes/admin/documents";
import { Route as AdminGdprErasureRoute } from "./routes/admin/gdpr-erasure";

import { Route as TenantLayoutRoute } from "./routes/tenant/_layout";
import { Route as TenantDashboardRoute } from "./routes/tenant/dashboard";
import { Route as TenantMyCardsRoute } from "./routes/tenant/my-cards";
import { Route as TenantCardsRoute } from "./routes/tenant/cards";
import { Route as TenantHoldersRoute } from "./routes/tenant/holders";
import { Route as TenantBudgetsRoute } from "./routes/tenant/budgets";
import { Route as TenantBudgetDetailRoute } from "./routes/tenant/budget-detail";
import { Route as TenantUsersRoute } from "./routes/tenant/users";
import { Route as TenantSyncStatusRoute } from "./routes/tenant/sync-status";
import { Route as TenantMonthDetailRoute } from "./routes/tenant/month-detail";
import { Route as TenantPayDetailRoute } from "./routes/tenant/pay-detail";
import { Route as TenantMicrogroupIndexRoute } from "./routes/tenant/microgroup-index";
import { Route as TenantMicrogroupInviteRoute } from "./routes/tenant/microgroup-invite";

import { Route as PMicrogroupTokenRoute } from "./routes/p/microgroup/$token";
import { Route as PInviteTokenRoute } from "./routes/p/invite/$token";

/**
 * Build the route tree by composing all children under `RootRoute`.
 *
 * Admin layout = children: 14 admin stuby.
 * Tenant layout = children: 5 tenant stuby.
 * Direct root children: index + 4 public auth routes + 2 consent routes.
 */
export const routeTree = RootRoute.addChildren([
  IndexRoute,
  LoginRoute,
  ForgotPasswordRoute,
  ResetPasswordRoute,
  ProfileChangePasswordRoute,
  ConsentIndexRoute,
  ConsentRePromptRoute,
  PMicrogroupTokenRoute,
  PInviteTokenRoute,
  AdminLayoutRoute.addChildren([
    AdminDashboardRoute,
    AdminSyncRoute,
    AdminDocumentsRoute,
    AdminBudgetsIndexRoute,
    AdminBudgetsDetailRoute,
    AdminDistributionRoute,
    AdminAnomaliesRoute,
    AdminPrefakturaceRoute,
    AdminPaymentAccountsRoute,
    AdminBillingGroupsRoute,
    AdminBillingGroupDetailRoute,
    AdminHoldersRoute,
    AdminTenantsRoute,
    AdminConsentUploadsRoute,
    AdminConsentVersionsRoute,
    AdminCardsRoute,
    AdminCredentialsRoute,
    AdminUsersDetailRoute,
    AdminPushAssistRoute,
    AdminMicrogroupRequestsRoute,
    AdminUserInvitesRoute,
    AdminGdprErasureRoute,
  ]),
  TenantLayoutRoute.addChildren([
    TenantDashboardRoute,
    TenantMyCardsRoute,
    TenantCardsRoute,
    TenantHoldersRoute,
    TenantBudgetsRoute,
    TenantBudgetDetailRoute,
    TenantUsersRoute,
    TenantSyncStatusRoute,
    TenantMonthDetailRoute,
    TenantPayDetailRoute,
    TenantMicrogroupIndexRoute,
    TenantMicrogroupInviteRoute,
  ]),
]);

/**
 * Sidebar navigation registry — used pro `auth-guards.spec.ts` smoke test
 * ("Each route reachable from Sidebar click"). Source of truth = TanStack
 * Router routeTree, ale tento export je explicit pro testy.
 */
export const SIDEBAR_REGISTRY = {
  admin: [
    "/admin/dashboard",
    "/admin/sync",
    "/admin/budgets",
    "/admin/distribution",
    "/admin/anomalies",
    "/admin/microgroup-requests",
    "/admin/user-invites",
    "/admin/cards-to-invalidate",
    "/admin/payment-accounts",
    "/admin/billing-groups",
    "/admin/holders",
    "/admin/tenants",
    "/admin/push-assist",
    "/admin/consent-uploads",
    "/admin/consent/versions",
    "/admin/credentials/axigon",
    "/admin/gdpr-erasure",
  ],
  tenant: [
    "/tenant/dashboard",
    "/tenant/my-cards",
    "/tenant/cards",
    "/tenant/holders",
    "/tenant/budgets",
    "/tenant/users",
    "/tenant/sync-status",
    "/tenant/microgroup",
    "/tenant/microgroup/invite",
  ],
  public: [
    "/login",
    "/forgot-password",
  ],
} as const;
